import { Directive, ElementRef, OnInit } from '@angular/core';
import { Auth } from './auth.service';

@Directive({
  selector: '[cwAdminOnly]'
})
export class AdminOnlyDirective implements OnInit {
  constructor(private auth: Auth,
              private _elementRef: ElementRef) {
  }

  ngOnInit(): void {
    if (!this.auth.user.superAdmin) {
      let el: HTMLElement = this._elementRef.nativeElement;
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/admin-only.directive.ts